import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SecurityService {
    public bearerToken: string;
    public pdfUri: string;
    public pdfDataSourceUri: string;
    public textItemsUri: string;
    public annotationsUri: string;

    public initToken() {
        const hash = (location.hash || location.search).substring(1);

        const result = hash.split('&').reduce(
            function (reslt, item) {
                const parts = item.split('=');
                reslt[parts[0]] = parts[1];
                return reslt;
            },
            { bearer: '', url: '', meta: '', annots:'', error: '', texts: '' },
        );

        if (!result.error) {
            this.bearerToken = result.bearer;
            this.pdfUri = decodeURIComponent(result.url);
            this.pdfDataSourceUri = decodeURIComponent(result.meta);
            this.textItemsUri = decodeURIComponent(result.texts);
            this.annotationsUri = decodeURIComponent(result.annots);
        }
    }
}
